const gnavFixed = (): false | void | undefined => {
  const target = document.getElementById('js-gnav');
  const kv = document.getElementById('js-header-kv');

  const side_breakpoint_tb = window.matchMedia('(min-width: 60.0625em)');

  if (target !== null && kv !== null) {
    if (!side_breakpoint_tb.matches) {
      return false;
    } else {
      const rect = target.getBoundingClientRect();
      const scroll = window.pageYOffset || document.documentElement.scrollTop;
      const targetPosition = rect.top + scroll;

      window.addEventListener('scroll', function () {
        const realTimeScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (targetPosition <= realTimeScroll) {
          target.style.cssText = 'position: fixed; bottom: auto; top: 0;';
        } else if (targetPosition >= realTimeScroll) {
          target.style.cssText = 'position: absolute; top: auto; bottom: 0;';
        }
      });
    }
  }
};
export { gnavFixed };
